"use strict";

const { get } = require("jquery");
const config = require('../../../../../config/locales_json/packs/private/admin/local_careers.json');
const language = $('body').data("language");

// Class definition

var UniversitiesDatatable = function() {
  // Private functions
  var _init = function() {
      var datatable = $('#kt_datatable_local_careers').KTDatatable({
          // datasource definition
          data: {
            type: 'remote',
            method: 'GET',
            source: {
              read: {
                url: '/admin/carreras/get_local_careers.json?scope='+$('#kt_datatable_local_careers').data('scope')+'&status='+$('#kt_datatable_local_careers').data('status'),
                method: 'GET',
                map: function(data) {
                  //console.log(data)
                  //$("#kt_subheader_total").html(data.length + " Total")

                  setTimeout(() => {
                    $('div#kt_datatable_local_careers .tp').tooltip('enable');
                  }, 2000);

                  return data.data
                }
              },
            },
            pageSize: 20,
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
          },

          // layout definition
          layout: {
              scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
              footer: false, // display/hide footer
          },

          // column sorting
          sortable: true,

          pagination: true,

          translate: {
            records: {
              processing: getTranslationValue(config, [language, "UniversitiesDatatable", "translate", "records-processing"], 'Cargando...'),
              noRecords: getTranslationValue(config, [language, "UniversitiesDatatable", "translate", "records-noRecords"], 'No existen carreras en el sistema')
            },
            toolbar: {
              pagination: {
                items: {
                  default: {
                    first: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-first"], 'Primero'),
                    prev: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-prev"], 'Anterior'),
                    next: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-next"], 'Siguiente'),
                    last: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-last"], 'Último'),
                    more: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-more"], 'Más páginas'),
                    input: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-input"], 'Página number'),
                    select: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-select"], 'Selecciona el tamaño de la página')
                  },
                  info: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "info"], 'Mostrando {{start}} - {{end}} de {{total}} carreras')
                }
              }
            }
          },

          // columns definition
          columns: [{
              field: 'name',
              title: getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "name", "title"], 'Carrera'),
              width: 300,
              template: function(data) {
                var name = data.name;

                var output = '<div class="d-flex align-items-center">\
                    <div class="ml-0">\
                        <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">' + name + '</div>\
                    </div>\
                </div>';

                return output;
              },
          }, {
              field: 'nicename',
              title: getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "nicename", "title"], 'País'),
              width: 120,
              template: function(data) {
                var output = '<div class="font-weight-bolder mb-0">' + data.nicename + '</div>';

                return output;
            },
          }, {
              field: 'Status',
              title: getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Status", "title"], 'Estado'),
              width: 100,
              // callback function support for column rendering
              template: function(row) {
                if(row.is_valid){
                  const validText = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Status", "valid-output"], 'Validada');
                  var output = '<span class="label label-lg font-weight-bold label-inline label-open">'+validText+'</span>';
                } else {
                  const inValidText = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Status", "invalid-output"], 'No Validada');
                  var output = '<span class="label label-lg font-weight-bold label-inline label-closed">'+inValidText+'</span>';
                }

                return output;
              },
          }, {
              field: 'Actions',
              title: getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "title"], 'Acciones'),
              sortable: false,
              width: 130,
              overflow: 'visible',
              autoHide: false,
              template: function(row) {
                if(row.is_deletable){
                  const editTitle = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "is_deletable", "output_a_1"], 'Editar');
                  const deleteTitle = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "is_deletable", "output_a_2"], 'Eliminar');

                  var output = '<div class="d-flex align-items-center container-actions-table">\
                                  <a href="/admin/carreras/'+ row.id +'/edit" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="'+editTitle+'"><i class="far fa-edit"></i></a>\
                                  <button type="button" class="icon delete-button tp" data-toggle="tooltip" data-theme="dark" title="'+deleteTitle+'" data-id="'+ row.id +'" data-toggle="modal" data-target="#delete_local_career_modal">\
                                    <i class="fas fa-trash-alt"></i>\
                                  </button>\
                                </div>';
                } else {
                  const editTitle = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "is_deletable_else", "output_a_1"], 'Editar');
                  const deleteTitle = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "is_deletable_else", "output_a_2"], 'Eliminar');
                  var output = '<div class="d-flex align-items-center container-actions-table">\
                                  <a href="/admin/carreras/'+ row.id +'/edit" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="'+editTitle+'"><i class="far fa-edit"></i></a>\
                                  <button type="button" class="icon delete-button not-delete tp" data-toggle="tooltip" data-theme="dark" title="'+deleteTitle+'" data-id="'+ row.id +'" data-toggle="modal" data-target="#delete_local_career_modal">\
                                    <i class="fas fa-trash-alt"></i>\
                                  </button>\
                                </div>';
                }

                return output;
              }
          }],
          search: {
            input: $('#kt_subheader_local_careers_search_form'),
          }
      });
  };

  return {
    // public functions
    init: function() {
        _init();
    },
  };
}();

jQuery(document).ready(function() {
    if($("#kt_datatable_local_careers").length > 0){
      UniversitiesDatatable.init();
    }

    /*************
     * ELIMINAR CARRERAS
     *
     * - Logica de activacion de modal,
     * - Asignacion de informacion a hidden field del modal
     * - Validacion y ejecución del formulario
     */
    // Al hacer click en eliminar una carrera
    $("#kt_datatable_local_careers").on("click", ".delete-button", function(e){
        $('#delete_local_career_modal').modal('toggle')
        // Obtiene el id de la carrera
        var localCareerID = $(this).attr("data-id")
        // Asigna el id de la carrera en el campo hidden del modal
        $("#delete_local_career_modal #hidden_modal_id").val(localCareerID)
        // Se asigna la url correspondiente
        var url = '/admin/carreras/'+ localCareerID;
        $("#form_modal_delete_local_career").attr("action", url)
        // Si la carrera se debe archivar porque tiene usuarios con la carrera asignada
        if($(this).hasClass("not-delete")){
            const descriptionText = getTranslationValue(config, [language, "click-delete-button", "description_text"], 'Esta carrera ya está asociada a un postulante, no se puede eliminar pero si quedará archivado. Esta acción no se puede revertir.');
            const btnText = getTranslationValue(config, [language, "click-delete-button", "btn_text"], 'Archivar');

            // Modifica la descripcion del modal
            $("#delete_local_career_modal .modal-body .description").text(descriptionText)
            // Modifica el texto del boton
            $("#delete_local_career_modal .modal-footer #send_modal_delete_local_career_form").text(btnText)
            // Agrega la clase not-delete para que al enviar el formulario muestre el texto de "Archivando..."
            $("#delete_local_career_modal .modal-footer #send_modal_delete_local_career_form").addClass("not-delete")
        // Si la carrera debe eliminarse modifica la info del modal por si anteriormente el modal fue abierto
        // por alguna carrera que se debio archivar
        } else {
            const descriptionText = getTranslationValue(config, [language, "click-delete-button", "else_description_text"], 'Esta acción no se puede revertir.');
            const btnText = getTranslationValue(config, [language, "click-delete-button", "else_btn_text"], 'Eliminar');

            // Modifica la descripcion del modal
            $("#delete_local_career_modal .modal-body .description").text(descriptionText)
            // Modifica el texto del boton
            $("#delete_local_career_modal .modal-footer #send_modal_delete_local_career_form").text(btnText)
            // Quita la clase not-delete para que al enviar el formulario muestre el texto de "Eliminando..."
            $("#delete_local_career_modal .modal-footer #send_modal_delete_local_career_form").removeClass("not-delete")
        }

    })

    // Al cerrar el modal limpia la url y el hidden
    $("#delete_local_career_modal .close").on("click", function(e){
        cleanLocalCareerModalFields()
    })

    // Al hacer click en confirmar eliminacion de universidad
    $("#delete_local_career_modal #cancel_modal_delete_local_career_form").on("click", function(e){
        cleanLocalCareerModalFields()
    })

    // Al hacer click en eliminar carrera
    $("#delete_local_career_modal #send_modal_delete_local_career_form").on("click", function(e){
        // Valida que el campo hidden tenga información
        var localCareerID = $("#delete_local_career_modal #hidden_modal_id").val()
        // Si tiene informacion ejecuta el formulario
        if(localCareerID.length > 0) {
            // Se desabilitan las acciones
            // Si se esta archivando una universidad
            if($(this).hasClass("not-delete")){
                const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-career-form", "localCareerId-length-not-delete"], 'Archivando...');

                // Cambia el texto del boton a Archivando
                $(this).addClass("disabled").text(disabledText)
            // De lo contrario esta eliminando una universidad
            } else {
                const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-career-form", "localCareerId-length-not-delete-else"], 'Eliminando...');

                // Cambia el texto del boton a Eliminando
                $(this).addClass("disabled").text(disabledText)
            }

            $("#delete_local_career_modal #cancel_modal_delete_local_career_form").addClass("disabled")
            $("#delete_local_career_modal #close_delete_local_career_modal").addClass("disabled")
            $("#form_modal_delete_local_career").submit()
        } else {
            const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-career-form", "else-localCareerId-length"], 'Hubo un problema y no se pudo eliminar la carrera. Por favor intente más tarde.');
            // Si no se puede eliminar
            $(".modal-body").find(".error-modal").remove()
            $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+disabledText+'</p></div>')
        }
    })

    // Limpia el campo hidden y la url del form
    function cleanLocalCareerModalFields(){
        // Limpia si hay errores
        $(".modal-body").find(".error-modal").remove()
        // Limpia el campo hidden
        $("#delete_local_career_modal #hidden_modal_id").val(null)
        // Se limpia la url correspondiente
        var url = '';
        $("#form_modal_delete_local_career").attr("action", url)
    }
    /*************
     * FIN ELIMINAR CARRERA
     */
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
